import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import i18n from '../../i18n';
import TableBody from '@material-ui/core/TableBody';
import Icon from '@material-ui/core/Icon';
import React, {useState} from 'react';
import costCenterQueries from "../../queries/costCenterQueries";
import {withStyles} from '@material-ui/core';
import Query from 'react-apollo/Query';
import GraphQlLoading from '../GraphQl/Loading';
import GraphQlError from '../GraphQl/Error';
import CostCenterEdit from './CostCenterEdit';
import costCenterMutations from '../../mutations/costCenterMutations';
import {getMutationName} from '../Form/utils';
import Button from '@material-ui/core/Button';


const validateValuesBeforeSave = async (costCenter) => {

    if(costCenter.number === '' || costCenter.name === '') {
        costCenter = undefined;
    }
    return costCenter;
};

const saveCostCenter = async (costCenter) => {
    const mutation = costCenter.id > 0 ? costCenterMutations.updateCostCenter : costCenterMutations.createCostCenter;
    const mutationName = getMutationName(mutation);

    let data = await validateValuesBeforeSave(costCenter);

    if(data){
        const {data: result} = await window.apolloClient.mutate({mutation, variables: {...data}})
            .catch((e) => { console.log('graphQLErrors', e ) });
        return result[mutationName];
    }
};

const CostCenterList = (props) => {
    let [adds, setAdds] = useState({data: []});
    let [canAdd, setCanAdd] = useState(true);

    return (
        <React.Fragment>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell scope="col" scope="col" style={{width:'15%'}}>{i18n.get('config.cost_center.number')}</TableCell>
                        <TableCell scope="col">{i18n.get('config.cost_center.self')}</TableCell>
                        {/*<TableCell scope="col">{i18n.get('config.cost_center.color')}</TableCell>
                        <TableCell scope="col">
                            <Tooltip title={i18n.get('')}>
                                <span>{i18n.get('config.cost_center.closed')}</span>
                            </Tooltip>
                        </TableCell>
                        */}
                        <TableCell scope="col" style={{width:'15%'}}> </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <Query
                        query={costCenterQueries.allCostCenters}
                    >
                        {({loading, error, data}) => {
                            if (loading) {
                                return <TableRow><TableCell colSpan={5}><GraphQlLoading/></TableCell></TableRow>;
                            }
                            if (error) {
                                return <TableRow><TableCell colSpan={5}><GraphQlError/></TableCell></TableRow>;
                            }

                            return data.costcenters.data && data.costcenters.data.length > 0 &&
                                data.costcenters.data.map((cc, idx) => (
                                        <CostCenterEdit key={`costCenter_${idx}`} values={cc} setCanAdd={setCanAdd} onChange={(cc) => {
                                            saveCostCenter(cc).then(data => { data && data.id && setCanAdd(true) });
                                        }}/>
                                    ),
                                );
                        }}
                    </Query>
                    {adds && adds.data && adds.data.length > 0 && adds.data.map((cc, idx) => (
                        <CostCenterEdit key={`newCostCenter_${idx}`} values={cc} setCanAdd={setCanAdd} edit={true} onChange={(cc) => {
                            saveCostCenter(cc).then(data => { data && data.id && setCanAdd(true)  });
                        }}/>
                    ))}
                </TableBody>
            </Table>

            {canAdd &&(
                <Button
                    variant="contained" size="small"
                    onClick={() => {
                        adds.data.push({id: null, number: '' , name: '', color: '', closed: false});
                        setAdds({data: adds.data});
                        setCanAdd(false);
                    }}
                    className={props.classes.spacing}
                >
                    <Icon>add</Icon> {i18n.get('config.cost_center.add')}
                </Button>
            )}
        </React.Fragment>
    );
};

const styles = theme => ({
    spacing: {
        marginTop: theme.spacing.unit * 2
    },
    span: {
        display: 'inline',
        margin: '0 5px',
    },
});

export default withStyles(styles)(CostCenterList);
